export default "__VITE_ASSET__BrxZMQNQ__"